import api from "../../../../../api/api";

// Fetches the list of default subjects; returns the API response payload.
export const getSubjects = async (token) => {
  try {
    const response = await api.get("/students/subjects/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch subjects:", error);
    throw error;
  }
};

export const validateSubject = async (subjects, token) => {
  try {
    const response = await api.post(
      "/students/validate-subject/",
      { subjects },
      { headers: { Authorization: `Token ${token}` } },
    );
    if (response.data?.valid) {
      return false;
    }
    return response.data?.message;
  } catch (error) {
    console.error("Failed to validate subject:", error);
    throw error;
  }
};

// Fetches the list of interests; returns the API response payload.
export const getInterests = async (token) => {
  try {
    const response = await api.get("/students/interests/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch interests:", error);
    throw error;
  }
};

/**
 * Saves only the subject list onto an existing student profile. Used by the
 * standalone subject popup — the onboarding wizard sends subjects as part of
 * its full `students/create-student/` payload instead.
 */
export const updateStudentSubjects = async (subjects, token) => {
  try {
    const formData = new FormData();
    // The API expects subjects as a comma-separated string (same as the
    // profile settings screen).
    formData.append("subject", subjects.join(","));

    const response = await api.put("students/update-student/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Token ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to update subjects:", error);
    throw error;
  }
};
